import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from '@arco-design/web-react';
import { Avatar } from './Avatar';
import './AvatarDropdown.css';

interface UserProfile {
  name: string;
  email: string;
  picture: string;
}

interface AvatarDropdownProps {
  user: UserProfile;
  onLogout: () => void;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const AvatarDropdown: React.FC<AvatarDropdownProps> = ({
  user,
  onLogout,
  size = 'medium',
  className = ''
}) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    onLogout();
  };

  const dropList = (
    <div className="avatar-dropdown-menu">
      {/* User Info Header */}
      <div className="dropdown-user-info">
        <div className="dropdown-user-avatar">
          <Avatar
            imageUrl={user.picture}
            name={user.name}
            size="medium"
          />
        </div>
        <div className="dropdown-user-details">
          <div className="dropdown-user-name">{user.name}</div>
          <div className="dropdown-user-email">{user.email}</div>
        </div>
      </div>

      <div className="dropdown-divider"></div>

      {/* Navigation Items */}
      <div className="dropdown-nav-section">
        <button
          className="dropdown-nav-item"
          onClick={() => handleNavigation('/profile/pets')}
        >
          <span className="dropdown-nav-tile">
            <img src="/assets/dog-outlined.svg" alt="" className="dropdown-nav-icon" />
          </span>
          <span>My Pets</span>
          <img src="/assets/right.svg" alt="" className="dropdown-nav-arrow" />
        </button>

        <button
          className="dropdown-nav-item"
          onClick={() => handleNavigation('/appointments')}
        >
          <span className="dropdown-nav-tile">
            <span className="dropdown-nav-icon dropdown-nav-icon--calendar" />
          </span>
          <span>My Appointments</span>
          <img src="/assets/right.svg" alt="" className="dropdown-nav-arrow" />
        </button>

        <button
          className="dropdown-nav-item"
          onClick={() => handleNavigation('/profile/edit')}
        >
          <span className="dropdown-nav-tile">
            <span className="dropdown-nav-icon dropdown-nav-icon--user" />
          </span>
          <span>Edit Profile</span>
          <img src="/assets/right.svg" alt="" className="dropdown-nav-arrow" />
        </button>
      </div>

      <div className="dropdown-divider"></div>

      {/* Logout */}
      <div className="dropdown-logout-section">
        <button
          className="dropdown-logout-item"
          onClick={handleLogout}
        >
          <span className="dropdown-nav-tile dropdown-nav-tile--danger">
            <img src="/assets/login.svg" alt="" className="dropdown-logout-icon" />
          </span>
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );

  return (
    <Dropdown droplist={dropList} position="bottom" trigger="click">
      <div className={`avatar-dropdown ${className}`}>
        <Avatar
          imageUrl={user.picture}
          name={user.name}
          size={size}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </Dropdown>
  );
}; 